import axios from 'axios'
import { CADASTRAR_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarVeiculo (veiculo) {
  const url = `${URL}/veiculo/cadastrar`;
  return dispatch => axios.post(url, veiculo, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_VEICULO,
        payload: response
      })
  );
}
